export default __webpack_public_path__ + "static/media/profile.738a898c.svg";